<template>
  <v-snackbar 
    v-model="snackbar.ativo" 
    :color="snackbar.color" 
    :timeout="snackbar.timeout"
  >
    {{ snackbar.mensagem }}
    <v-btn text @click="desabilitaSnackbar">Fechar</v-btn>
  </v-snackbar>
</template>

<script>
import { mapState } from "vuex";
export default {
  computed: {
    ...mapState({
      snackbar: state => state.snackbar.snackBar
    })
  },
  methods: {
    desabilitaSnackbar() {
      this.$store.commit("snackbar/setarAtivo", false);
    }
  }
};
</script>
